import { render, staticRenderFns } from "./comment_dialog.vue?vue&type=template&id=3ca075e0&scoped=true&"
import script from "./comment_dialog.vue?vue&type=script&lang=js&"
export * from "./comment_dialog.vue?vue&type=script&lang=js&"
import style0 from "./comment_dialog.vue?vue&type=style&index=0&id=3ca075e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca075e0",
  null
  
)

export default component.exports